import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import ImageUpload from "@/components/admin/ImageUpload";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";

const DEFAULT_HERO_IMAGES = [
  "https://static.prod-images.emergentagent.com/jobs/69bc8a3c-ed6c-4b85-a9a2-ec966ad0ef18/images/22e1c01b0f2f82ef07be7ccc892b0efd2c3f9d29ea5fe94b47095f073f352d95.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/69bc8a3c-ed6c-4b85-a9a2-ec966ad0ef18/images/7c3710366a8aa1f38a17a4ebd1eca54660317c5ad425852d2e4d0750380c2a36.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/69bc8a3c-ed6c-4b85-a9a2-ec966ad0ef18/images/c96829e0de1001cf6f241ac7de24d28a8a20c4fa55fcbc9d0f1393a85c755ca5.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/69bc8a3c-ed6c-4b85-a9a2-ec966ad0ef18/images/12501d923922002e00bd25d6fe35093699461b3eca064c38aeea8d100dd961d3.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/69bc8a3c-ed6c-4b85-a9a2-ec966ad0ef18/images/a489ac78d70b280eee9f912f75afaf337a476638ea9b179a697aacaccb342326.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/69bc8a3c-ed6c-4b85-a9a2-ec966ad0ef18/images/4e1b85760efd0f91e8442fe0cbe9e966272c1244586d97a18d521d957a59ca17.jpeg",
];

export default function AdminAppearance() {
  const [m, setM] = useState({ enabled: false, text: "", bg_color: "#050d1e", text_color: "#ffd34e", speed: 20, font_size: 16 });
  const [gallery, setGallery] = useState([]);
  const [galSpeed, setGalSpeed] = useState(30);
  const [savingM, setSavingM] = useState(false);
  const [savingG, setSavingG] = useState(false);

  useEffect(() => {
    api.get("/site-extras").then((r) => { if (r.data.marquee) setM((s) => ({ ...s, ...r.data.marquee })); const imgs = r.data.hero_gallery || []; setGallery(imgs.length ? imgs : DEFAULT_HERO_IMAGES); setGalSpeed(r.data.hero_speed || 30); }).catch(() => {});
  }, []);

  const saveMarquee = async () => {
    setSavingM(true);
    try { await api.put("/marquee", { ...m, speed: Number(m.speed), font_size: Number(m.font_size) }); toast.success("Pasek zapisany"); }
    catch { toast.error("Błąd zapisu paska"); } finally { setSavingM(false); }
  };
  const saveGallery = async () => {
    setSavingG(true);
    try { await api.put("/hero-gallery", { images: gallery, speed: Number(galSpeed) }); toast.success("Galeria zapisana"); }
    catch { toast.error("Błąd zapisu galerii"); } finally { setSavingG(false); }
  };

  return (
    <div>
      <h2 className="font-display text-2xl font-bold text-ztk-navy dark:text-white">Pasek i galeria strony głównej</h2>

      <div className="mt-8 max-w-xl space-y-5 rounded-2xl border border-border bg-card p-6">
        <div className="flex items-center justify-between">
          <Label>Pasek przewijany (pod menu, nad numerem KRS)</Label>
          <Switch checked={m.enabled} onCheckedChange={(v) => setM({ ...m, enabled: v })} data-testid="marquee-enabled" />
        </div>
        <div>
          <Label>Tekst paska</Label>
          <Input value={m.text} onChange={(e) => setM({ ...m, text: e.target.value })} data-testid="marquee-text" className="mt-1.5" placeholder="np. Zapraszamy na konferencję branżową 2026!" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label>Kolor tła</Label>
            <Input type="color" value={m.bg_color} onChange={(e) => setM({ ...m, bg_color: e.target.value })} data-testid="marquee-bg" className="mt-1.5 h-10 p-1" />
          </div>
          <div>
            <Label>Kolor tekstu</Label>
            <Input type="color" value={m.text_color} onChange={(e) => setM({ ...m, text_color: e.target.value })} data-testid="marquee-color" className="mt-1.5 h-10 p-1" />
          </div>
          <div>
            <Label>Prędkość (s na przewinięcie, mniej = szybciej)</Label>
            <Input type="number" min={4} max={120} value={m.speed} onChange={(e) => setM({ ...m, speed: e.target.value })} data-testid="marquee-speed" className="mt-1.5" />
          </div>
          <div>
            <Label>Wielkość tekstu (px)</Label>
            <Input type="number" min={10} max={48} value={m.font_size} onChange={(e) => setM({ ...m, font_size: e.target.value })} data-testid="marquee-size" className="mt-1.5" />
          </div>
        </div>
        <div className="rounded-lg border p-3" style={{ backgroundColor: m.bg_color }}>
          <p className="truncate font-semibold" style={{ color: m.text_color, fontSize: `${m.font_size}px` }}>{m.text || "Podgląd paska"}</p>
        </div>        <Button onClick={saveMarquee} disabled={savingM} className="gap-1.5 bg-ztk-blue" data-testid="marquee-save">
          {savingM ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Zapisz pasek
        </Button>
      </div>

      <div className="mt-8 max-w-xl space-y-4 rounded-2xl border border-border bg-card p-6">
        <div>
          <Label>Galeria na stronie głównej (auto-przewijana, 4 na raz)</Label>
          <p className="mt-1 text-xs text-muted-foreground">Zdjęcia obok napisu „30 lat doświadczenia". Dodaj kilka — będą się przewijać automatycznie.</p>
          <div className="mt-3">
            <ImageUpload value={gallery} multiple label="Zdjęcia galerii" onChange={setGallery} />
          </div>
        </div>
        <div>
          <Label>Czas przewijania (sekundy, mniej = szybciej)</Label>
          <Input type="number" min={5} max={120} value={galSpeed} onChange={(e) => setGalSpeed(e.target.value)} data-testid="hero-gallery-speed" className="mt-1.5 w-40" />
        </div>
        <Button onClick={saveGallery} disabled={savingG} className="gap-1.5 bg-ztk-blue" data-testid="hero-gallery-save">
          {savingG ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Zapisz galerię
        </Button>
      </div>
    </div>
  );
}
